import {useMultiStyleConfig} from '@chakra-ui/react';
import {defineCssVars, defineStyleConfig, type StyleFunctionProps} from '@chakra-ui/styled-system';
import {createAnatomy} from '@zag-js/anatomy';

const vars = defineCssVars(`label`, [`font-size`, `line-height`, `font-weight`]);

export const labelAnatomy = createAnatomy(`text`, [`root`]).build();

const truncate = {
  textOverflow: `ellipsis`,
  whiteSpace: `nowrap`,
  overflow: `hidden`,
};

export const labelTheme = defineStyleConfig({
  baseStyle: ({isTruncated}: StyleFunctionProps & {isTruncated?: boolean} = {} as any) => ({
    [vars[`font-weight`].variable]: `fontWeights.label.md`,
    [vars[`font-size`].variable]: `fontSizes.label.md`,
    [vars[`line-height`].variable]: `lineHeights.label.md`,

    fontFamily: `inter`,
    fontWeight: vars[`font-weight`].reference,
    fontSize: vars[`font-size`].reference,
    lineHeight: vars[`line-height`].reference,
    color: `text.primary`,
    ...(isTruncated && truncate),
  }),
  sizes: {
    lg: {
      [vars[`font-weight`].variable]: `fontWeights.label.lg`,
      [vars[`font-size`].variable]: `fontSizes.label.lg`,
      [vars[`line-height`].variable]: `lineHeights.label.lg`,
    },
    md: {
      [vars[`font-weight`].variable]: `fontWeights.label.md`,
      [vars[`font-size`].variable]: `fontSizes.label.md`,
      [vars[`line-height`].variable]: `lineHeights.label.md`,
    },
    sm: {
      [vars[`font-weight`].variable]: `fontWeights.label.sm`,
      [vars[`font-size`].variable]: `fontSizes.label.sm`,
    },
  },
  defaultProps: {
    size: `md`,
  },
});

export const useLabelStyleConfig = (props?: Parameters<typeof useMultiStyleConfig>[1]) => {
  return useMultiStyleConfig(`Label`, props ?? {});
};
